import axiosServices from './request';

const Convert = axiosServices('/convert/v1.0');

const Commoncenter = axiosServices('/commoncenter/v1.0');

export default {

  // check 文件
  checkTick: Convert('get', 'leafFile/checkTick'),

  // upload file
  updateFinish: Convert('post', 'leafFile/updateFinish'),

  //获取当前ip
  getIP: Commoncenter('get', 'companyIp/hasCompanyIp')

};
